import { useState } from 'react';
import moment from 'moment';
import { map, sortBy, get, toNumber } from 'lodash';
import { isEmpty } from '@aws-amplify/core';

const useOrderShopperLogs = (firebase, orderId) => {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(false);
    const msgNotFound = 'No se encontraron registros para esta orden.';
    const [initMessage, setInitMessage] = useState('Ingrese número de orden');

    const addDateFromTsField = (doc) => {
        const docData = doc.data();

        return {
            typeLog: 'logs',
            ...docData,
            date: moment(docData.ts.toDate()).format('YYYY-MM-DD HH:mm:ss')
        };
    };

    const getDoc = (doc, type) => {
        const docData = doc.data();

        return {
            typeLog: type,
            ...docData,
            message: type === 'notification' ? get(docData, 'message') : get(docData, 'eventType'),
            date: type === 'notification'
                ? moment.unix(docData.ts.seconds).add(docData.ts.nanoseconds / 1000000000, 'seconds').format('YYYY-MM-DD HH:mm:ss')
                : moment(toNumber(get(docData, 'dateTimestamp'))).format('YYYY-MM-DD HH:mm:ss')
        };
    };

    const fetchLogs = async () => {
        if (orderId) {
            setLoading(true);
            const orderLogsRef = await firebase.collection('order-logs').doc(orderId);
            const orderLogsDoc = await orderLogsRef.get();

            if (orderLogsDoc.exists) {
                const logsDoc = await orderLogsRef.collection('logs').get();
                const logsActionDoc = await orderLogsRef.collection('logs-action').get();
                const notificationsDoc = await orderLogsRef.collection('notifications').get();

                const logs = map(logsDoc.docs, addDateFromTsField);
                const logsAction = map(logsActionDoc.docs, (doc) => getDoc(doc, 'action'));
                const notifications = map(notificationsDoc.docs, (doc) => getDoc(doc, 'notification'));

                const allLogs = [...logs, ...logsAction, ...notifications];

                isEmpty(allLogs) && setInitMessage(msgNotFound);
                setLogs(sortBy(allLogs, 'date'));
                setLoading(false);
            } else {
                setInitMessage(msgNotFound);
                setLogs([]);
                console.error("El documento 'order-logs' no existe para el orderId proporcionado.");
            }
            setLoading(false);
        } else {
            setLogs([]);
            setInitMessage('Ingrese número de orden');
        }
    };

    return { logs, fetchLogs, loading, initMessage };
};

export default useOrderShopperLogs;
